/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import OverrideChairSchedule from './OverrideChairSchedule/index'
import React from 'react'
import ScheduleNote from './ScheduleNote/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/TimeGrid/FullCalendarTimegrid/SlotDialog/Content/Content",
  onClose
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'ScheduleNote'
let slotDialogScheduleNoteValueData = fromData.useDataFormat({ viewPath,
context: 'slot_dialog',
path: 'schedule_note',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: slotDialogScheduleNoteValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'ScheduleNote'}>
<ScheduleNote
  viewPath={`${viewPath}/ScheduleNote`}
 onClose={onClose}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'OverrideChairSchedule'}>
<OverrideChairSchedule
  viewPath={`${viewPath}/OverrideChairSchedule`}
 onClose={onClose}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}